// API helper for zones operations
import { API_BASE_URL as BASE_URL, buildUrl, getUserDepartment } from "./base";
import { withCsrfHeaders } from "./csrf";
import { apiJson, apiFetch } from './apiFetch';

// Helper function to get user department and create headers
const getApiHeaders = () => {
  const userDepartment = getUserDepartment();

  return {
    "Content-Type": "application/json",
    "X-User-Department": userDepartment,
  };
};

// Get all zones with pagination
export const apiGetAllZones = async (page = 1, limit = 10) => {
  try { return await apiJson(`${BASE_URL}/zones?page=${page}&limit=${limit}`); }
  catch (error) { console.error("Error fetching zones:", error); throw error; }
};

// Search zones
export const apiSearchZones = async (searchParams, page = 1, limit = 10) => {
  try {
    const queryParams = new URLSearchParams({ page: String(page), limit: String(limit), ...searchParams });
    return await apiJson(`${BASE_URL}/zones/search?${queryParams.toString()}`);
  } catch (error) { console.error("Error searching zones:", error); throw error; }
};

// Create new zone
export const apiCreateZone = async (zoneData) => {
  const response = await apiFetch(buildUrl("/zones"), {
    method: "POST",
    headers: await withCsrfHeaders(getApiHeaders()),
    body: JSON.stringify(zoneData),
  });
  if (!response.ok) { const errorData = await response.json().catch(() => ({})); throw new Error(errorData.error || "Failed to create zone"); }
  return await response.json();
};

// Update zone
export const apiUpdateZone = async (id, zoneData) => {
  try {
    const response = await apiFetch(`${BASE_URL}/zones/${id}`, {
      method: "PUT",
      headers: await withCsrfHeaders(getApiHeaders()),
      body: JSON.stringify(zoneData),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) { console.error("Error updating zone:", error); throw error; }
};

// Delete zone
export const apiDeleteZone = async (id) => {
  try {
    const response = await apiFetch(`${BASE_URL}/zones/${id}`, {
      method: "DELETE",
      headers: await withCsrfHeaders(getApiHeaders()),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) { console.error("Error deleting zone:", error); throw error; }
};
